export enum COMPONENT_ID {
  APP_OUTLET_WRAPPER = "app_outlet_wrapper",
  MAIN_NAVIGATION = "main-navigation",
  SETTINGS_NAVIGATION = "settings-navigation",
  CONTENT_WRAPPER = "content-wrapper",
  ACCOUNT_PAGE_SCROLL_AREA = "account-page-scroll-area",
}
